export const BaseDict = {
    balls: "B",
    strikes: "S",
    outs: "O",
    hits: "H",
    runs: "R",
    inningsPhraseShort: "Inn",
    inningsPhraseLong: "Innings",
    innsuffix: "",
    inn1suffix: "st",
    inn2suffix: "nd",
    inn3suffix: "rd",
    inn4suffix: "th",
    inn5suffix: "th",
    inn6suffix: "th",
    inn7suffix: "th",
    inn8suffix: "th",
    inn9suffix: "th",
    inn10suffix: "th",
    inn11suffix: "th",
    inn12suffix: "th",
    inn13suffix: "th",
    inn14suffix: "th",
    inn15suffix: "th",
    inn16suffix: "th",
    inn17suffix: "th",
    inn18suffix: "th",
    inn19suffix: "th"
};
//# sourceMappingURL=dict.js.map